export class CrmFilterService {
  public static checkFilterForReducers(state: any, action: any): boolean {
    if (!state?.filter?.managerId) {
      return true;
    }

    return state?.filter?.managerId === action.payload?.manager?.id;
  }
}
